import React, { Component } from 'react';
import { connect } from 'react-redux';
import marked from 'marked';
import './AboutStihl.css';
// import { stihlTimelines } from '../config/config.js';

class AboutStihl extends Component {
  
  render () {

    const pageAboutStihl = this.props.pages.filter(page => page.name === 'about_stihl');

    if(pageAboutStihl.length > 0){
      return <div
        className="about-stihl inner-container"
        dangerouslySetInnerHTML={{ __html: marked(pageAboutStihl[0].content) }}
      />
    }else{
      return null;
    }

    // const Timelines = stihlTimelines.map((elem, index) => <div key={index} className="timeline">
    //   <div className="timeline-time">{elem.time}</div>
    //   <div className="timeline-description">{elem.description}</div>
    // </div>)

    // return (
    //   <div className="about-stihl inner-container">
    //     <div className="columns about-stihl-title">
    //       <div className="column">
    //         <div className="about-stihl-image-1">
    //           <img src="http://li1861-248.members.linode.com:1337/uploads/f48da53d78ed46b38dd8f28ce4237061.png"/>
    //         </div>
    //         <h2 className="main-color">Since 1926</h2>
    //       </div>
    //       <div className="column">
    //         <h3 className="text-align-right">一流品質、</h3>
    //         <h3 className="text-align-right">以顧客為中心、</h3>
    //         <h3 className="text-align-right">創新。</h3>
    //       </div>
    //     </div>

    //     <div className="about-stihl-timelines">
    //       {Timelines}
    //     </div>
    //   </div>
    // )
  }
}

const mapStateToProps = state => ({
  pages: state.pages,
});

export default connect(mapStateToProps)(AboutStihl);



// WEBPACK FOOTER //
// ./src/components/AboutStihl.js